require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-joan-kerulis.json") })
        }
      }, "path---es-articles-tags-joan-kerulis");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-joan-kerulis!./.cache/json/es-articles-tags-joan-kerulis.json
// module id = 2375
// module chunks = 231608221292675